@if (availableGames$ | async; as games) {
  @if (isVisible(games)) {
    <button mat-stroked-button
            class="scope-switcher-button"
            [matMenuTriggerFor]="scopeMenu"
            data-testid="scope-switcher">
      <mat-icon>{{ (activeGame$ | async) ? 'sports_esports' : 'public' }}</mat-icon>
      <span class="scope-label" data-testid="scope-switcher-label">{{ (activeGame$ | async)?.ShortName || (activeGame$ | async)?.Name || 'All Games' }}</span>
      <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
    </button>

    <mat-menu #scopeMenu="matMenu">
      @if (canAccessGlobal()) {
        <button mat-menu-item
                (click)="selectGlobal()"
                data-testid="scope-switcher-global">
          <mat-icon>public</mat-icon>
          <span>All Games</span>
        </button>
      }
      @for (game of games; track game.Id) {
        <button mat-menu-item
                (click)="selectGame(game)"
                [attr.data-testid]="'scope-switcher-game-' + game.Id">
          <mat-icon>sports_esports</mat-icon>
          <span [attr.title]="game.Name">{{ game.ShortName || game.Name }}</span>
        </button>
      }
    </mat-menu>
  }
}
